import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { Subject } from 'rxjs';
import type { ModalKindStandalone } from './types';

export class ModalStandaloneResolverSignalService {
  private _alreadyResolved: ModalKindStandalone[] = [];

  public doLoadNewModal$: Subject<ModalKindStandalone> = new Subject<ModalKindStandalone>();
  public doUnloadModal$: Subject<ModalKindStandalone> = new Subject<ModalKindStandalone>();

  public resolve(kind: ModalKindStandalone) {
    return (state: boolean): void => {
      if (this._alreadyResolved.includes(kind) && !state) {
        this._alreadyResolved = this._alreadyResolved.filter(
          (resolvedKind: ModalKindStandalone) => resolvedKind !== kind
        );
        this.doUnloadModal$.next(kind);
      }
      if (!this._alreadyResolved.includes(kind) && state) {
        this._alreadyResolved.push(kind);
        this.doLoadNewModal$.next(kind);
      }
    };
  }
}

export function provideModalStandaloneResolverSignalService(): ModalStandaloneResolverSignalService {
  return provideSingleton(ModalStandaloneResolverSignalService, () => new ModalStandaloneResolverSignalService());
}
